<template>
  <v-layout
    :style="'background-color:' + bgColor"
    justify-space-between
    align-center
    align-content-center
    style="position:relative;"
  >
    <v-btn
      v-if="canOpen"
      @click="$emit('open')"
      outline
      fab
      small
      color="#848484"
      style="position:absolute; left: -37px; margin:0; height: 36px; width: 36px; border-radius: 4px;"
    >
      <v-icon v-if="isOpen">keyboard_arrow_up</v-icon>
      <v-icon v-else>keyboard_arrow_down</v-icon>
    </v-btn>
    <v-flex xs2>
      <h3 class="pt-2">案件予算： {{ index + 1 }}</h3>
    </v-flex>
    <v-flex xs3>
      <h4 class="pt-2">
        <AppPeriod
          :start="item.summary.startTime"
          :end="item.summary.endTime"
        />
      </h4>
    </v-flex>
    <v-flex xs1>
      <h4 class="pt-2">
        <AppCurrency :value="item.summary.budget" />
      </h4>
    </v-flex>
    <v-flex v-if="errorMessage.length > 0" class="red--text no-wrap" xs2>
      {{ errorMessage }}
    </v-flex>
    <v-spacer />
    <v-flex xs1>
      <v-layout justify-center>
        <v-chip
          v-if="item.summary.requestStatus === 'rejected'"
          outline
          disabled
          color="red"
          >却下</v-chip
        >
        <v-chip
          v-else-if="item.summary.requestStatus === 'waiting'"
          outline
          disabled
          color="#F57C00"
          >申請中</v-chip
        >
      </v-layout>
    </v-flex>
    <v-flex xs2>
      <template
        v-if="item.summary.requestStatus === 'rejected' && !item.isApproved"
      >
        <v-btn
          v-if="resubmittable"
          @click="$emit('closeAndEditInsertionOrder')"
          small
          >案件予算の再申請へ</v-btn
        >
      </template>
      <v-layout
        v-else-if="item.canEditCampaignBudgets && !readonly"
        justify-center
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="addCampaignBudget" small>
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>キャンペーン予算追加</span>
        </v-tooltip>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    readonly: Boolean,
    resubmittable: Boolean,
    isOpen: Boolean,
    canOpen: Boolean,
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    bgColor() {
      return this.item.summary.requestStatus === 'rejected'
        ? '#FFCDD2'
        : '#c2cfd9'
    },
  },
  methods: {
    addCampaignBudget() {
      this.$emit('clickAddButton')
    },
  },
}
</script>
<style scoped></style>
